import React, { useContext, useState ,useEffect, useRef} from "react";
import { LanguageContext} from '../../context'
import './Languageselector.css'
import { useQueryParam, StringParam } from 'use-query-params';
import { useParams,useNavigate } from 'react-router-dom';
import Translate from "../Translate/Translate";
import deleteIcon from "../../Images/Header/delete.svg"

const LanguageSelector = () => {

   const {switchLang,language}=useContext(LanguageContext);
   const [active,setActive]=useState(false);
   const [isClose,setIsClose]=useState('open');
   const [classOpenClose,setClassOpenClose]=useState('arrow close');
   const {langParam}=useParams();
   const refClose=useRef(null);
   const refMenu=useRef(null);

   const navigate = useNavigate();



  const changeLanguage = (event) => {
    var currentPath=window.location.pathname.replace(`/${language}`,"");
    //currentPath=currentPath.substring(currentPath.indexOf('/'))
    navigate(`/${event.target.title.toLocaleLowerCase()}${currentPath}${window.location.search}`)
    
   switchLang(event.target.title.toLocaleLowerCase());
   toggleLang();
    return false;
    

  }
  const toggleLang=()=>{
    setIsClose(isClose=='close'?'open':'close')
    setClassOpenClose("arrow "+isClose)
    setActive(!active);
    if(active){
      refMenu.current.focus();
    }
    else{
      refClose.current.focus();
    }
    return false;
  }

  const handleClose=()=>{
    refClose.current.focus();
  }

  const getLang=()=>{
    if(language.toLocaleLowerCase()=="he")
      return "עברית";
    if(language.toLocaleLowerCase()=="en")
      return "English";
  }

  useEffect(()=>{  
    if(langParam != undefined ){
      if(langParam!="he" && langParam!="en"){
        navigate("/404page");
      }
      else if(language!=langParam){
        switchLang(langParam);
      }
    } 
  },[]);

  return (

<div className="lang-container">
  <a className="current-lang" onClick={toggleLang} href="#" ref={refMenu} aria-haspopup="true" aria-expanded="false">
    <div className={classOpenClose} ></div>
    <div className="lang-txt" aria-label={getLang()}>{language.toLocaleUpperCase()}</div>
  </a>

 
    <ul className={active?'select-lang active':'select-lang'} aria-label="תפריט שפות">
    <div ><a href="javascript:void(0)"  className="close-button" aria-label="שפות" ref={refClose} onClick={toggleLang}>
                <img src={deleteIcon} alt="close" /></a></div>
      <li className="lang" ><input type="button"  value="עברית" title="He"   onClick={changeLanguage}></input> </li>
      <li className="lang" ><input type="button"  value="English" title="En" onClick={changeLanguage} ></input> </li>
      <li className='offset lastDivClose' tabIndex="0" onBeforeInput={handleClose} onFocus={handleClose}><Translate>MustCloseSection</Translate></li>	
    </ul>
</div>
  );

};


export default LanguageSelector;